import SelectList from "../../assets/SelectList";
import StandForm from "./Form";
import * as constants from "../../assets/constants";
import React from "react";
import {
    RichCell,
    Switch,
    SimpleCell,
    Separator,
    Header,
    ModalRoot,
    ModalPage,
    ModalPageHeader,
    PanelHeaderButton,
    Div,
    List,
    Button,
    ButtonGroup
} from "@vkontakte/vkui";
import {Icon28SettingsOutline, Icon24Cancel, Icon20AddCircleFillGreen, Icon24BrowserBack, Icon24Search} from "@vkontakte/icons";
import {AdaptivityContext} from "../../assets/constants";
import StandsManagers from "../../api/references/managers/standsManagers";
import withOffline from "../../components/withOffline";
import AlphabetFilter from "../../components/AlphabetFilter";


class StandsSelectList extends SelectList {

    constructor(props) {
        super(props);
        
        // Загружаем настройки из localStorage
        const savedSettings = this.loadSettings();
        
        const state = {
            current_brand: {},
            Alfavit: [],
            letter: '',
            showSettingsModal: false,
            selectedGroups: savedSettings.selectedGroups || [],
            showKeyboard: savedSettings.showKeyboard || false
        }

        this.state = {
            ...this.state,
            ...state
        }
    }
    
    // Ключ для сохранения настроек в localStorage
    SETTINGS_KEY = 'brands_select_list_settings';
    
    // ID для модального окна настроек
    MODAL_BRANDS_SETTINGS = 'modal_brands_settings';
    
    // Загрузка настроек из localStorage
    loadSettings = () => {
        try {
            const saved = localStorage.getItem(this.SETTINGS_KEY);
            if (saved) {
                return JSON.parse(saved);
            }
        } catch (error) {
            console.error('Ошибка загрузки настроек:', error);
        }
        return { selectedGroups: [], showKeyboard: false };
    }
    
    // Сохранение настроек в localStorage
    saveSettings = () => {
        try {
            const settings = {
                selectedGroups: this.state.selectedGroups,
                showKeyboard: this.state.showKeyboard
            };
            localStorage.setItem(this.SETTINGS_KEY, JSON.stringify(settings));
        } catch (error) {
            console.error('Ошибка сохранения настроек:', error);
        }
    }
    
    // Открыть/закрыть модальное окно настроек
    openSettingsModal = () => {
        this.props.setActiveModal(this.MODAL_BRANDS_SETTINGS);
    }
    
    closeSettingsModal = () => {
        this.props.setActiveModal(constants.MODAL_SELECT_LIST);
    }
    
    // Переключение выбора группы оборудования
    toggleEquipmentGroup = (groupId) => {
        const { selectedGroups } = this.state;
        const index = selectedGroups.indexOf(groupId);
        
        let newSelectedGroups;
        if (index === -1) {
            newSelectedGroups = [...selectedGroups, groupId];
        } else {
            newSelectedGroups = selectedGroups.filter(id => id !== groupId);
        }
        
        this.setState({ selectedGroups: newSelectedGroups }, () => {
            this.saveSettings();
            // Перезагружаем список с новыми фильтрами
            this.getItems('', false, 1);
        });
    }
    
    // Переключение опции "вызывать клавиатуру"
    toggleShowKeyboard = () => {
        this.setState({ showKeyboard: !this.state.showKeyboard }, () => {
            this.saveSettings();
        });
    }

    getItems(search_ = '', append = false, page, letter) {
        if (this.props.items != undefined) {
            let items = [];
            this.props.items.map((el, i) => {
                items.push({name: el.Значение, external_id: el.Код, id: el.Код, descr: el.Тип})
                this.setState({items: items});
            })
        } else {
            const search = search_ ? search_ : this.state.search

            append = append == undefined ? false : append
            if (page == undefined) {
                page = this.state.page;
            }
            if (letter == undefined) {
                letter = this.state.letter;
            }
            
            // Формируем equipment_group_ids для отправки в API
            const equipment_group_ids = this.state.selectedGroups.length > 0 
                ? this.state.selectedGroups.join(',') 
                : '';

            this.setState({loading: true})
            StandsManagers.getList(
                {
                    show_deleted: false,
                    isOffline: this.props.isOffline,
                    search,
                    hideAnalogs: 1,
                    page,
                    letter,
                    epp: AdaptivityContext.isMobile ? 10 : 20,
                    equipment_group_ids  // Передаем выбранные группы оборудования
                }
            ).then((response) => {

                this.setState({loading: false})
                const items = append ? this.state.items : []
                let results = response.data.results

                results.map((el, i) => {
                    el.name = el.title
                    el.checked = this.props.current_item && this.props.current_item.collections && this.props.current_item.collections[el.id] ? true : false
                    el.uid = el.id
                    el.id = el.external_id ?? el.id
                    el.descr = el.descr ?? el.INN

                    items.push(el)
                })

                this.setState({items})
                this.setState({Alfavit: response.data.Alfavit || []})
                this.setState({cnt_items: response.data.iTotalRecords})
                this.setState({totalPages: response.data.iTotalPages})

            })
        }

    }

    receiveMessage = (event) => {

        if (event.data.type == "SetCurentBrandInMonitoring") {

            this.setState({current_brand: event.data.value})
        }
    }

    setLetter = (letter) => {
        this.setState({page: 1, letter, search: ''})
        setTimeout(() => {
            this.getItems('', false, 1, letter)
        }, 300)
    }

    renderRow = (item, index, last_store_klients_id = null) => {
        let backgroundColor = 'inherit'

        if (item.is_competitor) {
            backgroundColor = 'rgba(88,117,183,0.4)'
        }

        if (item.confirmed == 0) {
            backgroundColor = 'rgba(255,75,75,0.57)'
        }
        return <RichCell key={'select_obj' + index}
                         onClick={() => this.selectObject(index)} multiline
                         style={{
                             border: item.external_id && item.external_id == last_store_klients_id ? '1px solid orange' : 'inherit',
                             backgroundColor
                         }}
                         subhead={<div style={{
                             display: "flex",
                             flexDirection: "row",
                             alignItems: 'center'
                         }}>{item.is_competitor ? 'Конкурент' : ''}
                             {item.parent_id &&
                                 <div className="summary-chip danger">{'Аналог ' + item.parent_id.title}</div>}
                         </div>}

                         bottom={<div>

                             {item.childs && Array.isArray(item.childs) && item.childs.length > 0 &&
                                 <div style={{
                                     display: "flex",
                                     flexDirection: "row",
                                     alignItems: 'center'
                                 }}>Аналоги: {item.childs.map(child => <div
                                     className="summary-chip">{child.title}</div>)}</div>}
                         </div>
                         }
                         caption={item.confirmed == 0 ? <span style={{color: 'red'}}>Не пройдена модерация</span> : ''}
                         after={!this.props.no_multiselect &&
                             <Switch onClick={() => this.selectObject(index)} checked={item.checked}/>}
        >
            {item.title} {item.type_id > 0 ? <b>{this.types[item.type_id]}</b> : <b>Тип не указан</b>}
        </RichCell>
    }

    types = constants.getEquipmentTypes()
    
    // Метод для отрисовки модального окна настроек
    renderSettingsModal = () => {
        const equipmentGroups = constants.getEquipmentGroups();
        
        return (
            <ModalPage
                id={this.MODAL_BRANDS_SETTINGS}
                onClose={this.closeSettingsModal}
                settlingHeight={100}
                header={
                    <ModalPageHeader
                        before={<PanelHeaderButton onClick={this.closeSettingsModal}>
                            <Icon24BrowserBack/>
                        </PanelHeaderButton>}
                    >
                        Настройки отображения стендов групп
                    </ModalPageHeader>
                }
            >
                <Div>
                    <Header mode="secondary">Показывать стенды групп:</Header>
                    <List>
                        {Object.keys(equipmentGroups).map((groupId) => {
                            // Пропускаем "Не указан" (id = 0)
                            if (groupId === '0') return null;
                            
                            const isChecked = this.state.selectedGroups.includes(groupId);
                            
                            return (
                                <SimpleCell
                                    key={`group_${groupId}`}
                                    Component="label"
                                    after={
                                        <Switch
                                            checked={isChecked}
                                            onChange={() => this.toggleEquipmentGroup(groupId)}
                                        />
                                    }
                                >
                                    {equipmentGroups[groupId]}
                                </SimpleCell>
                            );
                        })}
                    </List>
                    
                    <Separator style={{ margin: '12px 0' }} />
                    
                    <List>
                        <SimpleCell
                            Component="label"
                            after={
                                <Switch
                                    checked={this.state.showKeyboard}
                                    onChange={this.toggleShowKeyboard}
                                />
                            }
                        >
                            вызывать клавиатуру
                        </SimpleCell>
                    </List>
                    
                    <Div>
                        <ButtonGroup mode="horizontal" stretched>
                            <Button 
                                stretched 
                                size="l"
                                onClick={this.closeSettingsModal}
                            >
                                Сохранить
                            </Button>
                        </ButtonGroup>
                    </Div>
                </Div>
            </ModalPage>
        );
    }

    render() {
        const last_store_klients_id = localStorage.getItem(constants.last_store_klients_items_key);
        const empty_rows_message = this.props.empty_rows_message ?? 'Ничего не найдено';
        
        return (
            <ModalRoot activeModal={this.props.activeModal}>
                {/* Модальное окно создания стенда */}
                <ModalPage
                    id={constants.MODAL_SELECT_LIST_ADD}
                    onClose={() => this.closeList()}
                    settlingHeight={100}
                    style={{zIndex: 9999999999999}}
                    header={
                        <ModalPageHeader className="sclads"
                                         before={<PanelHeaderButton
                                             onClick={() => this.closeList()}><Icon24BrowserBack/></PanelHeaderButton>}
                        >
                            {this.props.modal_title ? this.props.modal_title : this.props.title}
                        </ModalPageHeader>
                    }
                >
                    <Div style={{paddingBottom: '150px'}}>
                        {this.renderCreateForm()}
                    </Div>
                </ModalPage>

                {/* Основное модальное окно списка стендов */}
                <ModalPage
                    id={constants.MODAL_SELECT_LIST}
                    onClose={() => this.closeList()}
                    settlingHeight={100}
                    style={{zIndex: 9999999999999}}
                    header={
                        <ModalPageHeader className="sclads"
                                         before={<PanelHeaderButton
                                             onClick={() => this.closeList()}><Icon24BrowserBack/></PanelHeaderButton>}
                                         after={
                                             <div style={{display: 'flex'}}>
                                                 {/* Кнопка настроек */}
                                                 <PanelHeaderButton
                                                     onClick={this.openSettingsModal}
                                                 >
                                                     <Icon28SettingsOutline width={24} height={24}/>
                                                 </PanelHeaderButton>
                                                 
                                                 {this.props.setActiveModal && <PanelHeaderButton
                                                     onClick={() => {
                                                         if (this.props.isOffline) {
                                                             window.postMessage({
                                                                 type: 'error',
                                                                 text: 'В режиме offline невозможно добавить стенд'
                                                             })
                                                             return
                                                         }
                                                         this.setState({current_brand: {id: -1}})
                                                         this.props.setActiveModal(constants.MODAL_SELECT_LIST_ADD)
                                                     }}>
                                                     <Icon20AddCircleFillGreen/>
                                                 </PanelHeaderButton>}
                                                 <PanelHeaderButton
                                                     onClick={() => this.props.searchAct && this.props.current_user && this.props.current_user.meta.settings.search_klients_by_phone == '1' ?
                                                         this.props.searchAct() : this.toggleSearch()}>
                                                     <Icon24Search/>
                                                 </PanelHeaderButton>
                                             </div>
                                         }
                        >
                            {this.state.showSearch ?
                                <form onSubmit={e => {
                                    e.preventDefault();
                                    e.stopPropagation()
                                }}>
                                    <input
                                        autoFocus={this.state.showKeyboard}
                                        type="text"
                                        placeholder="Поиск"
                                        value={this.state.search}
                                        onChange={this.onSearchChange}
                                        style={{
                                            flexGrow: '1',
                                            maxWidth: '350px',
                                            padding: '8px 12px',
                                            border: '1px solid #ccc',
                                            borderRadius: '8px',
                                            fontSize: '15px'
                                        }}
                                    />
                                </form> : (this.props.modal_title ? this.props.modal_title : this.props.title)}
                        </ModalPageHeader>
                    }
                >
                    <AlphabetFilter
                        letters={this.state.Alfavit}
                        onLetterClick={this.setLetter}
                        activeLetter={this.state.letter}
                    />
                    
                    {this.props.header_info_message && <div style={{top: '0px'}}
                                                            className={AdaptivityContext.isMobile || true ? 'mobile-table-storage-header' : 'desktop-table-storage-header'}>
                        <Div>
                            <p>{this.props.header_info_message}</p>
                        </Div>
                    </div>}

                    <Div style={{
                        paddingBottom: '150px',
                        width: (this.state.Alfavit ? (AdaptivityContext.isMobile ? '88%' : '92%') : "inherit")
                    }}>
                        <List className="selectList-list" onScroll={this.handleScroll}>
                            {this.state.items && this.state.items.map((item, index) => (
                                this.renderRow(item, index, last_store_klients_id)
                            ))}
                            
                            {this.state.items.length > 0 || this.state.loading ? '' :
                                <RichCell key={'sel_lst0'} className="empty_rows_message">
                                    {empty_rows_message}
                                </RichCell>}
                        </List>
                    </Div>

                    <Div className={AdaptivityContext.isMobile ? 'action-board' : 'action-board desktop'}>
                        <ButtonGroup mode="horizontal" stretched>
                            <Button stretched size={AdaptivityContext.isMobile ? 'm' : 'l'}
                                    onClick={() => this.closeList()}
                            >Подтвердить</Button>
                        </ButtonGroup>
                    </Div>
                </ModalPage>
                
                {/* Модальное окно настроек */}
                {this.renderSettingsModal()}
            </ModalRoot>
        )
    }

    renderCreateForm() {
        return <StandForm

            item={this.state.current_brand}
            fromDoc
            eventType="SetCurentBrandInMonitoring"
            title_new="Новый стенд"
            title="Стенд"
            fields={
                {
                    title: {
                        required: true,
                        title: 'Наименование',
                        type: 'text'
                    },
                    is_competitor: {
                        title: 'Стенд конкурента',
                        type: 'checkbox',
                        value: true,
                        disabled: true
                    },
                    deleted: {
                        title: 'Запрет ввода',
                        type: 'checkbox',
                        value: false,
                        disabled: true
                    },
                    type_id: {
                        required: true,
                        title: 'Тип',
                        type: 'select',
                        options: this.types
                    },
                    group_id: {
                        required: true,
                        title: 'Товарная группа',
                        type: 'SelectObject',
                        nullValue: '',
                        options: constants.getEquipmentGroups()
                    },
                    trade_mark_id: {
                        title: 'Торговая марка',
                        nullValue: '',
                        type: 'SelectObject',
                        app: 'trademarks',
                        act: 'getList',
                        modal_title: 'Торговые марки'
                    },
                }
            }
            hideForm={() => this.props.setActiveModal(constants.MODAL_SELECT_LIST)}

        />
    }

}

export default withOffline(StandsSelectList)